import React from 'react'
import styled from 'styled-components'
import { useFormContext } from 'react-hook-form'
import get from 'lodash/get'
import ErrorMessage from './ErrorMessage'

const FieldWrapper = styled.div`
  margin-bottom: 16px;
`

const MessagesAndAnnotations = styled.div`
  display: flex;
  align-items: baseline;
`

export const Label = styled.label<{ error?: boolean }>`
  display: block;
  line-height: 1;
  font-size: ${({ theme }) =>
    theme?.['-ds-font-size-sm']?.['font-size']?.value};
  font-weight: 400;
  margin-bottom: 8px;
`

export type FieldProps = {
  name: string
  label?: React.ReactNode
  autocomplete?: boolean
  annotations?: React.ReactNode
  style?: React.CSSProperties
}

const Field: React.FC<FieldProps> = ({
  name,
  label,
  annotations,
  children,
}) => {
  const {
    formState: { errors },
  } = useFormContext()
  const error = get(errors, name)
  return (
    <FieldWrapper>
      {label && (
        <Label htmlFor={name} error={!!error}>
          {label}
        </Label>
      )}
      {children}
      <MessagesAndAnnotations>
        <ErrorMessage name={name} />
        <div style={{ marginLeft: 'auto' }}>{annotations}</div>
      </MessagesAndAnnotations>
    </FieldWrapper>
  )
}

export default Field
